import { render } from "./Elemental.vue?vue&type=template&id=6a66d0cc"
import script from "./Elemental.vue?vue&type=script&lang=js"
export * from "./Elemental.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__